import { isDebug } from '@/js/libs/is-debug';
const isDev = typeof window !== 'undefined' && window?.location?.host
    ? ['dev.', 'localhost', 'dev-cdn.'].some((l) => window.location.host.startsWith(l))
    : false;
const logsAllowed = () => isDev || isDebug();
/* eslint-disable no-console */
console.dev = {
    log: (...args) => logsAllowed() && console.log(...args),
    error: (...args) => console.error(...args),
    warn: (...args) => logsAllowed() && console.warn(...args),
    info: (...args) => logsAllowed() && console.info(...args),
    debug: (...args) => logsAllowed() && console.debug(...args),
    tag: (...tags) => {
        const tagPrefix = [`%c[${tags.join()}]`, 'color: #034eaf; background-color: #96f9f5; padding: 2px'];
        return {
            log: (...args) => console.dev.log(...tagPrefix, ...args),
            error: (...args) => console.dev.error(...tagPrefix, ...args),
            warn: (...args) => console.dev.warn(...tagPrefix, ...args),
            info: (...args) => console.dev.info(...tagPrefix, ...args),
            debug: (...args) => console.dev.debug(...tagPrefix, ...args),
            tag: (...moreTags) => console.dev.tag(...tags, ...moreTags),
        };
    },
};
